<template>
  <div class="main-width">
    <div class="page-title">Data Search & Data Download</div>
    <div-unit unitTitle="Searching for Protein Structure">
      <div style="display: flex; flex-direction: column; margin-bottom: 50px">
        <div>
          <p style="font-weight: bold; margin-left: 92px; font-size: 22px">
            Searching for Protein Structures:
          </p>
        </div>
        <div style="height: 10px"></div>
        <div style="display: flex; margin: 0 auto">
          <el-input
            v-model="fullText"
            placeholder="Enter the keyword"
            class="inupt-width"

          >
          </el-input>
          <!-- <el-button
            class="btn-submit"
            @click="submitFullText()"
            style="font-size: 22px; width: 120px"
            >Submit</el-button
          > -->
          
          <span class="btn-info single-info">
            <a
              @click="submitFullText()"
              hreflang="en"
              style="padding: 8px 0; color: #fff !important;font-size: 24px;width: 125px;"
              >Submit</a
            >
          </span>
        </div>
        <p style="margin-left: 92px; font-size: 18px">
          Example:
          <a
            href="/search-protein?api=fullText&keyword=RfaH"
            hreflang="en"
            class="search-color"
            >RfaH</a
          >;
          <a
            href="/search-protein?api=fullText&keyword=Translocase Inhibitor"
            hreflang="en"
            class="search-color"
            >Translocase Inhibitor</a
          >;
          <a
            href="/search-protein?api=fullText&keyword=Ferrochelatase"
            hreflang="en"
            class="search-color"
            >Ferrochelatase</a
          >;
          <a
            href="/search-protein?api=fullText&keyword=2XA7"
            hreflang="en"
            class="search-color"
            >2XA7</a
          >...
        </p>
      </div>

      <!-- <div style="display: flex; flex-direction: column; margin-bottom: 50px">
        <div>
          <p style="font-weight: bold; margin-left: 92px; font-size: 22px">
            Search for Protein Structures by xxx:
          </p>
        </div>
        <div>
          <p style="margin-left: 92px; font-size: 18px">
            <i class="icon iconfont icon--idea" aria-hidden="true"></i> Tips:
            Please select the category, then a list of yy under the selected
            category will be available.
          </p>
        </div>
        <div style="display: flex; margin: 0 auto">
          <el-select
            v-model="searchCategory"
            filterable
            default-first-option
            ref="searchSelect"
            placeholder="Step1: Please select a search category"
            class="inupt-width"
          >
            <el-option
              v-for="(item, index) in searchCategoryOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>


          
          <span class="btn-info single-info">
            <a
              @click="resetCategory()"
              hreflang="en"
              style="padding: 8px 0; color: #fff !important;font-size: 24px;width: 125px;"
              >Reset</a
            >
          </span>
        </div>
        <div style="height: 10px"></div>
        <div style="display: flex; margin: 0 auto">
          <el-select
            v-loading="searchCategoryResult_check"
            v-model="searchCategoryResult"
            filterable
            default-first-option
            ref="searchSelect"
            placeholder="Step2: Please select a yy"
            class="inupt-width"
          >
            <el-option
              v-for="(item, index) in searchCategoryResultOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>

          <span class="btn-info single-info">
            <a
              @click="submitCategory()"
              hreflang="en"
              style="padding: 8px 0; color: #fff !important;font-size: 24px;width: 125px;"
              >Submit</a
            >
          </span>
        </div>
      </div> -->

      <div style="display: flex; flex-direction: column; margin-bottom: 50px">
        <div>
          <p style="font-weight: bold; margin-left: 92px; font-size: 22px">
            Searching for Protein Structures by Sequence Similarity:
          </p>
        </div>
        <div>
          <p style="margin-left: 92px; font-size: 18px">
            <i class="icon iconfont icon--idea" aria-hidden="true"></i> Tips:
            Please enter the fasta format of the protein sequence. (
            <span
              class="input_example"
              @click="fastaExample('protein-example1')"
              ># Example1</span
            >,
            <span
              class="input_example"
              @click="fastaExample('protein-example2')"
            >
              # Example2</span
            >,
            <span
              class="input_example"
              @click="fastaExample('protein-example3')"
              ># Example3</span
            >
            )
          </p>
        </div>

        <div style="margin-left: 94px">
          <el-input
            type="textarea"
            v-model="seq_text"
            rows="6"
            style="width: 1020px; border-radius: 10px"
            class="protein-input"
          ></el-input>
        </div>
        <div
          style="display: flex; justify-content: space-evenly; margin-top: 20px"
        >
          <!-- <el-button
            class="btn-submit"
            @click="fastaReset()"
            style="font-size: 22px; width: 120px; border-radius: 10px"
            >Reset</el-button
          > -->
          <span class="btn-info single-info">
            <a
              @click="fastaReset()"
              hreflang="en"
              style="padding: 8px 0; color: #fff !important;font-size: 24px;"
              >Reset</a
            >
          </span>
          <!-- <el-button
            class="btn-submit"
            @click="fastaSubmit()"
            style="font-size: 22px; width: 120px; border-radius: 10px"
            >Submit</el-button
          > -->
          
          <span class="btn-info single-info">
            <a
              @click="fastaSubmit()"
              hreflang="en"
              style="padding: 8px 0; color: #fff !important;font-size: 24px;"
              >Submit</a
            >
          </span>
        </div>
      </div>
    </div-unit>

    <!-- <div v-if="pageName!='HomeView'"><DownloadPage></DownloadPage></div> -->
    
  </div>
</template>

<script>
import DivUnit from "@/components/DivUnit.vue";
// import DownloadPage from "@/views/DownloadPageDatabase.vue";
import api from "@/api/index";
export default {
  data() {
    return {
      // localUrl: pathUrl.localUrl,
      fullText: "",
      searchCategory: "",
      searchCategoryOptions: [
        {
          label: "Classification",
          value: "classificationshort",
        },
        {
          label: "Organism",
          value: "organism",
        },
        {
          label: "Method",
          value: "method",
        },
        {
          label: "Ligand",
          value: "hetshort",
        },
      ],

      searchCategoryResult: "",
      searchCategoryResultOptions: [],
      searchCategoryResult_check: false,
      seq_text: "",
      mission_id: "",
    };
  },
  
  props: {
    pageName: {
      type: String,
      required: true, default: 'DefaultPage',
    },
  },
  components: {
    DivUnit,
    // DownloadPage
  },
  methods: {
    submitFullText() {
      this.$router.push({
        path: `/search-protein`,
        query: {
          api: "fullText",
          keyword: this.fullText,
        },
      });
    },
    resetCategory() {
      this.searchCategory = "";
      this.searchCategoryResult = "";
    },
    submitCategory() {
      this.$router.push({
        path: `/search-protein`,
        query: {
          api: "searchCategory",
          category: this.searchCategory,
          keyword: this.searchCategoryResult,
        },
      });
    },
    fastaExample(example) {
      let xhr = new XMLHttpRequest();
      xhr.open("GET", `/example/${example}.fasta`, false);
      xhr.overrideMimeType("text/html;charset=utf-8");
      xhr.send(null);
      this.seq_text = xhr.responseText;
    },
    fastaReset() {
      this.seq_text = "";
    },
    fastaSubmit() {
      var mission_id = "" + new Date().getTime();
      var post_data = {
        seq_text: this.seq_text,
        mission_id: mission_id,
      };
      if (this.seq_text.trim() == "") {
        this.$alert("Please enter the correct protein sequence", "Error", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Close",
        });
      } else {
        api.postSequence(post_data).then((res) => {
          console.log(res);
        });
        this.$router.push("/search-protein-by-seq?id=" + mission_id);
      }
    },
  },
  watch: {
    searchCategory: {
      handler: function () {
        this.searchCategoryResult_check = true;
        this.searchCategoryResult = "";
        api.getCategorySearch(this.searchCategory).then((res) => {
          this.searchCategoryResult_check = false;
          this.searchCategoryResultOptions = res.data.options;
        });
      },
      deep: true,
    },
  },
};
</script>
<style lang="less" scoped>
@color-theme: #4d97e0;
@bg-theme: #f5f8fd;
@color-theme-hover: #409eff94;
a {
  color: @color-theme !important;
}
.input_example {
  color: @color-theme;
}

.search-color {
  color: @color-theme;
}
/deep/input {
  height: 50px;
  padding-left: 15px;
  font-size: 20px;
  border: 2px solid @color-theme!important;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  outline: none;
}

/deep/.el-button {
  font-size: 22px !important;
  height: 50px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  border: 2px;
  background: @color-theme;
}

/deep/.el-button:hover,
.el-button:focus {
  background: @color-theme-hover;
}

/deep/.div-title {
  background: @color-theme;
}
/deep/.div-content {
  border-top: 0;
}
/deep/.div-unit {
  border: 3px solid @color-theme;
  border-color: @color-theme;
  background-color: @bg-theme;
}
/deep/.el-cascader__dropdown {
  width: 900px !important;
}
.inupt-width{
  width: 890px;
    padding-right: 10px;
}
</style>
